import { Component, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { State } from '@app/state';
import { BaseComponent } from '@components/base.component';
import { MessageService } from '@app/services/message.service';

@Component({
  selector: 'app-message-view-users',
  templateUrl: './message-view-users.component.html',
  styleUrls: [],
})
@Injectable()
export class MessageViewUsersComponent extends BaseComponent {

  public message: {
    name: string,
    uuid: string,
    created_by_user: any,
    created_user: any,
    created_at: string,
    userCount: number,
    user_count: number,
    recipient_count: number,
    recipients_with_attributes: any,
    users_with_attributes: any
  };

  public dataLoaded: boolean = false;

  // https://codeburst.io/using-the-plural-pipe-in-angular-2-2bcc67a14030
  // Make this into a global array for other models
  public userPluralMapping = {
    '=0': '0 users',
    '=1': '1 user',
    'other': '# users'
  };

  constructor(
    public activatedRoute: ActivatedRoute,
    public messageService: MessageService,
    public state: State,
    public router: Router
  ) {
    super();
    this.setObjects({
      route: activatedRoute,
      state,
      router,
      modelService: messageService
    });
    this.modelServiceGetOne(this.routeParams['id'], 'message').then(() => {
      this.dataLoaded = true;
    });
  }

  public closeSlideout() {
    this.state.message({ slideoutHide: true });
  }
}
